import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=05ca6682&scoped=true"
import script from "./Playlist.vue?vue&type=script&lang=ts"
export * from "./Playlist.vue?vue&type=script&lang=ts"
import style0 from "./Playlist.vue?vue&type=style&index=0&id=05ca6682&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca6682",
  null
  
)

export default component.exports